// composables/useSwatchesCart.js
import { ref, reactive } from 'vue'
import { useProductHelpers } from './productHelpers'

export function useSwatchesCart(runEngine, state) {
  const helpers = useProductHelpers()
  const trackEvent = inject("trackEvent")

  // Modal state for cart operations
  const modal = reactive({
    show: true,
    page: true,
    product: {
      qty: 0,
      packName: "",
      Coupon: [],
      variantID: 40029155524668,
    },
    upsell: {
      show: true,
      activate: false,
    },
    crosssell: {
      show: false,
      variantId: 32453656150076,
      activate: false,
    },
  })

  // Cart methods
  const setProductModal = (input) => {
    modal.product = {
      qty: input.qty,
      packName: input.packName,
      Coupon: input.Coupon,
      variantID: input.variantID,
    }
    modal.crosssell.variantId = input.crossSellID
  }

  const setChoice = (choice) => {
    if (modal.upsell.show === true) {
      modal.upsell.activate = choice
      modal.upsell.show = false
      modal.crosssell.show = true
    } else if (modal.crosssell.show === true) {
      modal.crosssell.activate = choice
      checkOut()
    }
  }

  const checkOut = () => {
    const crossSellId = modal.crosssell.activate && modal.crosssell.variantId
    performCheckout(
      modal.product.variantID,
      modal.upsell.activate ? modal.product.qty * 2 : modal.product.qty,
      modal.upsell.activate ? modal.product.Coupon[0] : modal.product.Coupon[1],
      modal.product.packName,
      null,
      crossSellId,
      trackEvent
    )
  }

  const addUpgradeToCart = (accepted) => {
    accepted ? onCheckout(state.upgrade) : onCheckout(state.regular)
  }

  const onCheckout = (Item) => {
    performCheckout(
      Item.varID,
      Item.quantity,
      Item.Coupon,
      Item.pack,
      null,
      null,
      trackEvent
    )
  }

  const addToCart = () => {
    const item = state.items[state.active.items]
    const variant = item.Variants[state.active.variants]
    const pack = variant.Pack[state.active.packs] 
    const variantID = variant.variant.VariantID
    if (typeof state.upgrades.CrossSellOffer !== "undefined") {
      handleCrossSellOffer(item, variant, pack, variantID)
    } else if (typeof state.upgrades.UpsellPackOffer !== "undefined") {
      handleUpsellPackOffer(item, variant, pack, variantID)
    } else if (state.isSubscription && helpers.hasSellingPlans(state.items, state.active.items, state.active.variants)) {
      handleSubscriptionCheckout(variantID, pack)
    } else {
      handleRegularCheckout(variantID, pack)
    }
  }
  const performCheckout = (variantId, quantity, coupon, packName, sellingPlanId = null, crossSellId = null, trackEvent) => {

    const checkoutItems = [];
    const packReward = state?.packRewards?.[state?.active?.packs];

    if (packReward) {
  
      packReward?.products.forEach((product) => {
        checkoutItems.push({
          id: product.id,
          quantity: product.quantity,
          coupon: product.coupon,
        });
      });
      checkoutItems.push({
        id: variantId,
        quantity: quantity,
        coupon: coupon,
        plan: sellingPlanId,
      });
      if(crossSellId){
        checkoutItems.push({
          id: crossSellId,
          quantity: 1,
          coupon: null,
        });
      }

      runEngine.checkoutWithItems(checkoutItems, trackEvent);
    }else{
      runEngine.checkout(
      variantId,
      quantity,
      coupon,
      packName,
      sellingPlanId,
      crossSellId,
      trackEvent
    );
    }
  };
  // Helper methods for addToCart
  const handleCrossSellOffer = (item, variant, pack, variantID) => {
    document.body.style.overflow = "hidden"
    const upgradeOffer = helpers.findUpgradeOffer(state.items, state.active.items, state.active.variants, pack.PackSize)
    const oferTa = upgradeOffer[0]
    const CrossSellVariant = JSON.parse(
      state.upgrades.CrossSellOffer.VariantId.VariantSKU
    )[helpers.getVariantType(variant.Name)]

    setProductModal({
      qty: helpers.formatPackSize(pack.PackSize),
      packName: pack.Name,
      Coupon: [oferTa.Coupon, pack.Coupon],
      variantID: variantID,
      crossSellID: CrossSellVariant,
    })

    setupUpgradeState(item, variant, pack, variantID, oferTa)
  }

  const handleUpsellPackOffer = (item, variant, pack, variantID) => {
    document.body.style.overflow = "hidden"
    const xUpgradeQty = helpers.findMatchingUpgradeOffer(state.upgrades.UpsellPackOffer, pack.PackSize)
    const oferTi = xUpgradeQty[0]
    const upgradeOffer = helpers.findUpgradeOffer(state.items, state.active.items, state.active.variants, oferTi.PackUpgrade)
    const oferTa = upgradeOffer[0]

    if (state.layoutPopup == "L02") {
      setProductModal({
        qty: helpers.formatPackSize(pack.PackSize),
        packName: pack.Name,
        Coupon: [oferTa.Coupon, pack.Coupon],
        variantID: variantID,
      })
    }

    setupUpsellState(item, variant, pack, variantID, oferTa, oferTi)
  }

  const handleSubscriptionCheckout = (variantID, pack) => {
    performCheckout(
      variantID,
      helpers.formatPackSize(pack.PackSize),
      pack.Coupon,
      pack.Name,
      helpers.getSellingPlan(state.items, state.active.items, state.active.variants, state.active.sellingPlan),
      null,
      trackEvent
    )
  }

  const handleRegularCheckout = (variantID, pack) => {
    performCheckout(
      variantID,
      helpers.formatPackSize(pack.PackSize),
      pack.Coupon,
      pack.Name,
      null,
      null,
      trackEvent
    )
  }

  const setupUpgradeState = (item, variant, pack, variantID, oferTa) => {
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: helpers.formatPackSize(pack.PackSize) * 2,
      PackDiff: helpers.formatPackSize(pack.PackSize) / 2,
      UpSell: {
        PreHeader: state.upgrades.UpsellOffer.PreHeader,
        Header: state.upgrades.UpsellOffer.Header,
        SubHeader: state.upgrades.UpsellOffer.SubHeader,
        Image: state.items[state.active.items].Variants[state.active.variants].Pack[state.active.packs].Image.url,
        ButtonText: "Yes! Upgrade My Order",
      },
      CrossSell: {
        Body: state.upgrades.CrossSellOffer.Body,
        Header: state.upgrades.CrossSellOffer.Header,
        Image: state.upgrades.CrossSellOffer.Image.url,
        PricenSave: state.upgrades.CrossSellOffer.PricenSave,
        ButtonText: "Yes! Upgrade My Order",
      },
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      show: true,
    }
  }

  const setupUpsellState = (item, variant, pack, variantID, oferTa, oferTi) => {
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: helpers.formatPackSize(oferTi.PackUpgrade),
      PackDiff: helpers.calculatePackDifference(oferTi.PackUpgrade, oferTi.PackSizeRun),
      PreHeader: oferTi.PreHeader,
      Header: oferTi.Header,
      SubHeader: oferTi.SubHeader,
      Image: oferTi.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      ButtonText: oferTi.ButtonText,
      show: true,
    }

    state.regular = {
      product: item.Name,
      variant: variant.Name,
      pack: pack.Name,
      quantity: helpers.formatPackSize(pack.PackSize),
      Coupon: pack.Coupon,
      varID: variantID,
    }
  }

  const handleButtonClick = (checkboxChecked) => {
    if (helpers.validateSubscriptionCheckbox(checkboxChecked, state.isSubscription)) {
      return true // Indicate checkbox needs to be checked
    } else {
      addToCart()
      return false
    }
  }

  return {
    modal,
    setProductModal,
    setChoice,
    addUpgradeToCart,
    addToCart,
    handleButtonClick,
  }
}